export const SHARE_BASE_URL = 'https://tonyte.app';
export const CUSTOM_SCHEME = 'tonyte';

export const DEEP_LINK_PREFIXES = [
  SHARE_BASE_URL,
  `${CUSTOM_SCHEME}://`,
];

const cleanBaseUrl = (baseUrl: string) => baseUrl.replace(/\/+$/, '');

const encodeShareId = (id?: string | null) => {
  const trimmed = typeof id === 'string' ? id.trim() : '';
  return trimmed ? encodeURIComponent(trimmed) : '';
};

export const buildTonyteEventPath = (eventId?: string | null) => {
  const encodedId = encodeShareId(eventId);
  return encodedId ? `/event/${encodedId}` : '';
};

export const buildTonyteProfilePath = (userId?: string | null) => {
  const encodedId = encodeShareId(userId);
  return encodedId ? `/profile/${encodedId}` : '';
};

export const buildTonyteVenuePath = (venueId?: string | null) => {
  const encodedId = encodeShareId(venueId);
  return encodedId ? `/venue/${encodedId}` : '';
};

export const buildTonyteOrganizerPath = (organizerId?: string | null) => {
  const encodedId = encodeShareId(organizerId);
  return encodedId ? `/organizer/${encodedId}` : '';
};

export const buildTonyteEventLink = (eventId?: string | null, baseUrl = SHARE_BASE_URL) => {
  const path = buildTonyteEventPath(eventId);
  return path ? `${cleanBaseUrl(baseUrl)}${path}` : '';
};

export const buildTonyteProfileLink = (userId?: string | null, baseUrl = SHARE_BASE_URL) => {
  const path = buildTonyteProfilePath(userId);
  return path ? `${cleanBaseUrl(baseUrl)}${path}` : '';
};

export const buildTonyteVenueLink = (venueId?: string | null, baseUrl = SHARE_BASE_URL) => {
  const path = buildTonyteVenuePath(venueId);
  return path ? `${cleanBaseUrl(baseUrl)}${path}` : '';
};

export const buildTonyteOrganizerLink = (organizerId?: string | null, baseUrl = SHARE_BASE_URL) => {
  const path = buildTonyteOrganizerPath(organizerId);
  return path ? `${cleanBaseUrl(baseUrl)}${path}` : '';
};

export const buildTonyteCustomSchemeEventLink = (eventId?: string | null) => {
  const encodedId = encodeShareId(eventId);
  return encodedId ? `${CUSTOM_SCHEME}://event/${encodedId}` : '';
};

export const buildTonyteCustomSchemeProfileLink = (userId?: string | null) => {
  const encodedId = encodeShareId(userId);
  return encodedId ? `${CUSTOM_SCHEME}://profile/${encodedId}` : '';
};
